import { useMemo } from "react"
import { NetworkColors, networkLabel } from "src/shared/enums/networkColors"

const NETWORK_ICONS: Record<string, string> = {
  meta: "bi-meta",
  facebook: "bi-facebook",
  instagram: "bi-instagram",
  pinterest: "bi-pinterest",
  snapchat: "bi-snapchat",
  snap: "bi-snapchat",
  google: "bi-google",
  linkedin: "bi-linkedin",
  vibe: "bi-tv",
  tiktok: "bi-tiktok",
  direct_mail: "bi-envelope",
}

export const ImpressionsByNetworkBar = ({ series }: { series: any[] }) => {
  const networkImpressions = useMemo(() => {
    const networks = series ?? []

    const impressionsPerNetwork = networks.map((network: any) => {
      const name: string = network.name
      const dataPoints: [number, number][] = network.data
      const total = dataPoints.reduce((sum, [, value]) => sum + value, 0)
      return { name, total }
    })

    const grandTotal = impressionsPerNetwork.reduce((sum, network) => sum + network.total, 0)

    return impressionsPerNetwork.map((network) => ({
      name: network.name,
      total: network.total,
      percent: grandTotal > 0 ? Math.round((network.total / grandTotal) * 100) : 0,
      color: NetworkColors[network.name.toUpperCase() as keyof typeof NetworkColors] ?? "#6c757d",
      icon: NETWORK_ICONS[network.name.toLowerCase()] ?? "bi-globe2",
    }))
  }, [series])

  return (
    <ul className="list-unstyled personal-goals-list mb-0">
      {networkImpressions.map((network) => (
        <li key={network.name}>
          <div className="d-flex align-items-center">
            <div className="me-2">
              <span className="avatar avatar-rounded" style={{ backgroundColor: `${network.color}20` }}>
                <i className={`bi ${network.icon} fs-18`} style={{ color: network.color }}></i>
              </span>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="d-block fw-semibold">
                  {networkLabel(network.name)}
                </span>
                <span className="d-block" style={{ color: "#8c9097" }}>
                  {network.total.toLocaleString()}
                </span>
              </div>
              <div className="progress progress-animate progress-xs" style={{ backgroundColor: `${network.color}20` }}>
                <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${network.percent}%`, backgroundColor: network.color }} />
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}
